import { render, staticRenderFns } from "./SettingMode.vue?vue&type=template&id=68b1b870&scoped=true&"
import script from "./SettingMode.vue?vue&type=script&lang=js&"
export * from "./SettingMode.vue?vue&type=script&lang=js&"
import style0 from "./SettingMode.vue?vue&type=style&index=0&id=68b1b870&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b1b870",
  null
  
)

/* custom blocks */
import block0 from "./SettingMode.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports